import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import StringInput from "../inputs/StringInput";
import FormField from "../inputs/FormField";
import PreviewDialog from "./PreviewDialog";
import ErrorInput from "../inputs/ErrorInput";
import { Input, Label, makeStyles } from "@fluentui/react-components";
import ProgressDialogContent from "./ProgressDialogContent";

const labelStyle = {
  color: "#828282"
};

const useStyles = makeStyles({
  text: {
    fontFamily: "var(--fontFamilyBase)",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "normal"
  }
});

export default function SaveNewProjectDialog({
  thumbnailUrl,
  initialName,
  onConfirm,
  onCancel,
  loading,
  message,
  progress
}) {
  const styles = useStyles();
  const [name, setName] = useState(initialName);
  const [isValid, setValid] = useState(true);

  const onChangeName = useCallback(
    (_ev, data) => {
      setName(_ev.target.value);
    },
    [setName]
  );

  const onConfirmCallback = useCallback(
    e => {
      e.preventDefault();
      if (isValid) onConfirm({ name });
    },
    [name, onConfirm, isValid]
  );

  const onCancelCallback = useCallback(
    e => {
      e.preventDefault();
      onCancel();
    },
    [onCancel]
  );

  return (
    <PreviewDialog
      imageSrc={thumbnailUrl}
      title="Publish"
      onConfirm={!loading ? onConfirmCallback : null}
      onCancel={!loading ? onCancelCallback : null}
      confirmLabel="Publish"
    >
      {loading && (
        <ProgressDialogContent
          className={styles.text}
          progress={progress}
          message={message}
        />
      )}
      {!loading && (
        <FormField>
          <Label htmlFor="name" style={labelStyle}>
            Name
          </Label>
          <Input
            type="text"
            style={{ width: "100%" }}
            appearance="filled-darker"
            id="name"
            required
            pattern={"[A-Za-z0-9-':\"(),.~ ]{4,64}"}
            title="Name must be between 4 and 64 characters and cannot contain underscores"
            value={name}
            onChange={onChangeName}
          />
          <ErrorInput
            message="Name must be between 4 and 64 characters and cannot contain underscores or special characters"
            regexPattern={/^[A-Za-z0-9-':\"(),.~ ]{4,64}$/}
            validateText={name}
            style={{ maxWidth: "200px" }}
            onInvalid={() => {
              setValid(false);
            }}
            onValid={() => {
              setValid(true);
            }}
          />
        </FormField>
      )}
    </PreviewDialog>
  );
}

SaveNewProjectDialog.propTypes = {
  thumbnailUrl: PropTypes.string.isRequired,
  initialName: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};
